'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { Text } from '@/components/Typography';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_stacktrace/product-roadmap/$roadmapId/_layout/history/')({
  component: RoadmapHistoryPage
});
function RoadmapHistoryPage() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'productRoadmap.detail'
  });
  return <VStack className="flex-1 items-center justify-center px-12 py-12">
      <Text variant="p" className="text-neutral-muted-on-fill">
        {t('preparing')}
      </Text>
    </VStack>;
}